/**
 * 全局hooks 获取用户信息
 */
import {
  getInvestAccount,
  getFundList,
  getInvestmentList,
  tztInvestAccountFundBalance
} from '@/service/myAccount/myAccount'

interface AccountType {
  adminId: number
  investAccountName: string
  investAccountNo: string
  mctCode: string // 1000 未众禄标识
  mctName: string
  tradeAcco: string
  [key: string]: any
}

// 选中的投资账户信息
export interface SelectAccountType {
  investAccountNo: string
  tradeAcco: string
}

export const useUserInfo = () => {
  // 获取用户信息
  const { getters } = useStore()
  const userInfo = computed(() => getters['moduleCommon/getUserInfo'])

  const accountOption = reactive<AccountType[]>([])

  const route = useRoute()

  // 获取持仓明细-账户枚举值
  const getTztInvestAccountFundBalance = async (userId?: number | string | undefined) => {
    return new Promise((resolve) => {
      tztInvestAccountFundBalance({ adminId: userId || userInfo.value?.id, moduleId: route?.meta?.pageId }).then(
        (res: { code: any; data: any }) => {
          const { code, data } = res
          resolve('')
          if (code === 0) {
            accountOption.length = 0
            Object.assign(accountOption, [])
            if (Array.isArray(data)) {
              data.forEach((val) => {
                const label = val.investAccountName
                accountOption.push({
                  ...val,
                  value: {
                    investAccountNo: val.investAccountNo,
                    tradeAcco: val.tradeAcco
                  },
                  label
                })
              })
            }
          }
        }
      )
    })
  }

  // 获取账户枚举值
  // managerId 管理人id(仅在管理人页面使用)
  const getAccountData = async (userId?: number | string | undefined, managerId?: number | string | undefined) => {
    return new Promise((resolve) => {
      const params: any = {
        adminId: userId || userInfo.value?.id,
        moduleId: route?.meta?.pageId
      }
      if (managerId) {
        params.managerId = managerId
      }
      getInvestAccount(params).then((res: { code: any; data: any }) => {
        const { code, data } = res
        resolve('')
        if (code === 0) {
          accountOption.length = 0
          Object.assign(accountOption, [])
          if (Array.isArray(data)) {
            data.forEach((val) => {
              const label = val.investAccountName
              accountOption.push({
                ...val,
                value: {
                  investAccountNo: val.investAccountNo,
                  tradeAcco: val.tradeAcco
                },
                label
              })
            })
          }
        }
      })
    })
  }

  const getHgtzzDetailsList = async () => {
    return new Promise((resolve) => {
      getInvestmentList({ adminId: userInfo.value?.id }).then((res: { code: any; data: any }) => {
        const { code, data } = res
        resolve('')
        if (code === 0) {
          accountOption.length = 0
          Object.assign(accountOption, [])
          if (Array.isArray(data)) {
            data.forEach((val) => {
              const label = val.investAccountName
              accountOption.push({
                ...val,
                value: val.investAccountNo,
                label
              })
            })
            if (data.length) {
              selectInvestAccount.value.investAccountNo = accountOption[0].value
            }
          }
        }
      })
    })
  }

  const fundlistOption = reactive<any[]>([])
  // 获取产品枚举值
  const getFundListFun = async () => {
    return new Promise((resolve) => {
      getFundList({ adminId: userInfo.value?.id }).then((res: { code: any; data: any }) => {
        const { code, data } = res
        resolve('')
        if (code === 0) {
          fundlistOption.length = 0
          Object.assign(fundlistOption, [])
          if (Array.isArray(data)) {
            data.forEach((val) => {
              fundlistOption.push({
                ...val,
                value: val.fundId,
                label: val.fundName
              })
            })
          }
        }
      })
    })
  }
  const initChoseAccount = () => {
    return {
      adminId: 0,
      investAccountName: '',
      investAccountNo: '',
      mctCode: '', // 1000 为众禄标识
      mctName: '',
      tradeAcco: '',
      showChannel: false
    }
  }

  // select下选中的账户信息
  const selectInvestAccount = ref<SelectAccountType>({
    investAccountNo: '',
    tradeAcco: ''
  })

  // 是否展示渠道标识信息
  const modifyShowChannel = (accountList: AccountType[]) => {
    const channelList: string[] = []

    if (Array.isArray(accountList)) {
      for (let i = 0, len = accountList.length; i < len; i++) {
        const account = accountList[i]
        if (account.mctCode && !channelList.includes(account.mctCode)) {
          channelList.push(account.mctCode)
        }
        if (channelList.length > 1) {
          break
        }
      }
    }

    return channelList.length > 1
  }

  const accountChoseInfo = initChoseAccount()
  // 获取选中的账户具体信息 & 判断是否显示交易账号
  const choseAccountItem = (obj: { tradeAcco: string; accountList: AccountType[]; key?: string }) => {
    const { tradeAcco, accountList, key } = obj

    const channelList: string[] = []
    Object.assign(accountChoseInfo, initChoseAccount())

    if (Array.isArray(accountList)) {
      accountList.forEach((account) => {
        if (tradeAcco === account[key || 'tradeAcco']) {
          Object.assign(accountChoseInfo, account)
        }

        if (!channelList.includes(account.mctCode)) {
          channelList.push(account.mctCode)
        }
      })
    }

    if (channelList.length > 1) {
      Object.assign(accountChoseInfo)
    }
  }

  return {
    userInfo,
    getAccountData,
    getTztInvestAccountFundBalance,
    accountOption,
    choseAccountItem,
    modifyShowChannel,
    accountChoseInfo,
    selectInvestAccount,
    getFundListFun,
    fundlistOption,
    getHgtzzDetailsList
  }
}
